export const getSelectedValues = (
  selectedItem,
  selectName,
  multiple,
  showFlag,
  selectOption,
) => {
  if (multiple) {
    const value = Array.isArray(selectedItem)
      ? selectedItem.map(item => item[selectOption])
      : [];

    const renderSelectedValues = Array.isArray(selectedItem)
      ? {
          value: selectedItem
            .map(item => item[selectName] || "")
            .filter(value => value !== "")
            .join(", "),
          ...(showFlag && {
            countryCode: selectedItem
              .map(item => (item.alpha2 || item.isoCode)?.toLowerCase())
              .filter(code => code !== undefined && code !== ""),
          }),
        }
      : { value: "" };

    return { value, renderSelectedValues };
  } else {
    const value = selectedItem ? selectedItem[selectOption] : "";
    const renderSelectedValues = {
      value: (selectedItem && selectedItem[selectName]) || "",
      ...(showFlag && {
        countryCode: selectedItem
          ? (selectedItem.alpha2 || selectedItem.isoCode)?.toLowerCase()
          : "",
      }),
    };

    return { value, renderSelectedValues };
  }
};
